import { render, staticRenderFns } from "./OccupationSkillsRatingTab.vue?vue&type=template&id=008b8c93&scoped=true"
import script from "./OccupationSkillsRatingTab.vue?vue&type=script&lang=js"
export * from "./OccupationSkillsRatingTab.vue?vue&type=script&lang=js"
import style0 from "./OccupationSkillsRatingTab.vue?vue&type=style&index=0&id=008b8c93&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008b8c93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('008b8c93')) {
      api.createRecord('008b8c93', component.options)
    } else {
      api.reload('008b8c93', component.options)
    }
    module.hot.accept("./OccupationSkillsRatingTab.vue?vue&type=template&id=008b8c93&scoped=true", function () {
      api.rerender('008b8c93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/employee/rating/partials/tabs/OccupationSkillsRatingTab.vue"
export default component.exports